import { useParams } from 'react-router-dom';
function useUrlParam(name, opts) {
    var params = useParams();
    var _opts_int;
    var int = (_opts_int = opts === null || opts === void 0 ? void 0 : opts.int) !== null && _opts_int !== void 0 ? _opts_int : false;
    var value_ = params[name];
    if (int) {
        var parsed = Number.parseInt(value_);
        if (isNaN(parsed)) {
            var _opts_onParseError;
            opts === null || opts === void 0 ? void 0 : (_opts_onParseError = opts.onParseError) === null || _opts_onParseError === void 0 ? void 0 : _opts_onParseError.call(opts);
        }
        return parsed;
    }
    return value_;
}
export default useUrlParam;
